import module from 'finanzas/module.js'

const schema = {
  empresas: {
    importe: 'number',
  },
  idMoneda: 'number',
  fecha: 'date',
}

function FinancesPosicionbancariaEstatus ($http, $filter) {
  this.get = function (id_moneda, fecha) {
    return $http.get('/api/bancos/reportes/estatus', {
      params: {id_moneda: id_moneda, fecha: $filter('date')(fecha, 'yyyy-MM-dd')},
      schema,
      cache: 'finances',
    })
  }
}

module.service('FinancesPosicionbancariaEstatus', FinancesPosicionbancariaEstatus)



// WEBPACK FOOTER //
// ./src/finanzas/services/Finances/Posicionbancaria/Estatus.js